/// <reference path="../modules/app.core.module.ts"/>
/// <reference path="../objects/variables.ts" />

module App.Core {

    var config = {
        appErrorPrefix: '', //Configure the exceptionHandler decorator
        appTitle: 'Werkplaatsplanner',
        version: '1.0.0'
    };

    export class Config {
        static configId = 'config';
    }

    appCore.value(Config.configId, config);

    appCore.config(
        ($logProvider: ng.ILogProvider, $stateProvider: angular.ui.IStateProvider,
            exceptionHandlerProvider: Blocks.IExceptionHandlerProvider, routehelperConfigProvider: Blocks.IRouterHelperProvider,
            $urlRouterProvider: angular.ui.IUrlRouterProvider) => {
            // turn debugging off/on (no info or warn)
            if ($logProvider.debugEnabled) {
                $logProvider.debugEnabled(true);
            }
            
            switch (App.Variables.configuratorType) {
                case 'carcheck':
                    $urlRouterProvider.otherwise(Constants.routeKeys.carcheck);
                    break;
                case 'tyrechange':
                    $urlRouterProvider.otherwise(Constants.routeKeys.tyrechange);
                    break;
                case 'tyrechange-afstoten':
                    $urlRouterProvider.otherwise(Constants.routeKeys.notyrechange);
                    break;
                case 'tyrechange-opslaan':
                    $urlRouterProvider.otherwise(Constants.routeKeys.notyrechange);
                    break;
                default:
                    $urlRouterProvider.otherwise(($injector, $location) => {
                        var ga = Functions.getParameterByName("_ga");
                        var gac = Functions.getParameterByName("gac");
                        return Constants.routeKeys.cardetail + (ga.length > 0 ? '?_ga=' + ga : '') + (gac.length > 0 ? (ga.length > 0 ? '&' : '?') + 'gac=' + gac : '');
                    });
            }

            // Configure the common route provider
            routehelperConfigProvider.config.$stateProvider = $stateProvider;
            routehelperConfigProvider.config.docTitle = config.appTitle + ': ';
            var resolveAlways = {
                ready: dataservice => {
                     return dataservice ? dataservice.ready : true;
                }
            };
            routehelperConfigProvider.config.resolveAlways = resolveAlways;

            // Configure the common exception handler
            exceptionHandlerProvider.configure(config.appErrorPrefix);
        });
}